function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError('Cannot call a class as a function');
    }
}
function _defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ('value' in descriptor)
            descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function _createClass(Constructor, protoProps, staticProps) {
    if (protoProps)
        _defineProperties(Constructor.prototype, protoProps);
    if (staticProps)
        _defineProperties(Constructor, staticProps);
    return Constructor;
}
var Bezel = function () {
    function Bezel(container) {
        var _this = this;
        _classCallCheck(this, Bezel);
        this.container = container;
        this.container.addEventListener('animationend', function () {
            _this.container.classList.remove('dplayer-bezel-transition');
        });
    }
    _createClass(Bezel, [{
            key: 'switch',
            value: function _switch(icon) {
                var flag = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'play';
                this.container.innerHTML = icon;
                this.container.classList.add('dplayer-bezel-transition');
                if (flag === 'play') {
                    this.container.classList.remove('dplayer-bezel-paused');
                } else {
                    this.container.classList.remove('dplayer-bezel-play');
                }
                this.container.classList.add('dplayer-bezel-' + flag);
            }
        }]);
    return Bezel;
}();
export default Bezel;